import React from 'react';

export default function IconNO() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FF4B55"
                d="M31.448 21.483H.552A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.552.517h30.896c.305 0 .552.247.552.552v19.862a.552.552 0 0 1-.552.552Z"
            />
            <path
                fill="#F5F5F5"
                d="M32 8.241H14.345V.517H8.828v7.724H0v5.518h8.828v7.724h5.517v-7.724H32V8.24Z"
            />
            <path
                fill="#41479B"
                d="M32 9.345H13.24V.517h-3.31v8.828H0v3.31h9.931v8.828h3.31v-8.828H32v-3.31Z"
            />
        </svg>
    );
}
